import { buildCommonFilters, embedFilter } from '../sharedFilters'

const DATASET_KEY = 'simulacrums'

const commonFilters = buildCommonFilters(DATASET_KEY, {
  INSTALLATION: { label: 'REMS' },
  USER: {},
  CENTER: { column: 'centers.name', label: 'Centro' },
  SECTOR: { column: 'sectors.name', label: 'Región' },
  REGION: { column: 'regions.name', label: 'Estado' },
  MUNICIPALITY: { column: 'municipalities.name', label: 'Municipio' },
  TENANT: false,
  STATUS: false,
})

export default {
  key: DATASET_KEY,
  label: 'Proced. Op. - Simulacros',
  timeColumn: 'simulacrum_form_answers.created_at',
  permission: { action: 'read', subject: 'Simulacrum' },

  tables: {
    simulacrum_form_answers: ["id", "id_simulacrum", "id_user", "id_template", "template_snapshot", "template_sources", "answers", "uuid", "data", "created_at", "updated_at"],
    simulacrums: ["id", "reference_number", "evaluation_date", "id_user", "id_unit", "title", "description", "created_at", "updated_at"],
    simulacrum_template: ["id", "uuid", "name", "data", "id_tenant", "id_user", "created_at", "updated_at"],
    simulacrum_status: ["id", "id_simulacrum", "id_user", "id_status", "created_at", "updated_at"],
    simulacrum_status_catalog: ["id", "name", "created_at", "updated_at"],
    simulacrum_form: ["id", "uuid", "name", "data", "id_tenant", "id_user", "created_at", "updated_at"],
    users: ["id", "id_unit", "id_maintenance_company", "image", "check_alarms", "frame_color", "id_profile", "user", "email", "password", "name", "first_name", "second_name", "config", "plate_number", "created", "updated", "active", "vpn_access", "allow_virtual_button_alarm", "allow_visual_notifications", "allowed_units_live_video_flows", "phone_number", "alarm_history_per_hours", "alarm_history_per_days", "alarm_history_by_records", "last_login", "video_wall", "active_sesion_video_wall", "id_country", "auth_two_factor_code", "auth_two_factor_time", "auth_two_factor_type", "verify_email_code", "verify_sms_code", "verify_sms", "verify_email", "online", "enabled_chat", "enabled_helpdesk"],
    units: ["id", "id_router", "description", "address_1", "address_2", "exterior_number", "suburb", "number", "postal_code", "id_country", "id_region", "id_sector", "active", "route", "plate_number", "vin", "driver", "provider", "owner", "company", "vehicle", "allow_virtual_button_alarm", "reaction_patrol", "id_alarms_levels", "active_digital_output", "needs_check", "id_municipality", "time_zone", "data", "comments", "id_category", "id_seproban", "rems", "sirh", "created_at", "updated_at"],
    sectors: ["id", "id_center", "name", "alcaldia", "provider", "created", "updated"],
    centers: ["id", "tenant_id", "name", "description", "updated", "created", "active"],
    regions: ["id", "name", "code", "country_id", "acronym", "created_at", "updated_at"],
  },

  views: [
    { value: 'bar', label: 'Barras' },
    { value: 'dona', label: 'Dona' },
    { value: 'ring', label: 'Pastel' },
    { value: 'dataframe', label: 'Lista', adminOnly: true },
    { value: 'timeseries', label: 'Tendencia' },
    { value: 'json', label: 'JSON', adminOnly: true },
  ],

  defaults: {
    field: 'units.description',
  },

  // The status comes from its history (one row per change). See useCurrentStatus.
  currentStatus: {
    recordColumn: 'simulacrums.id',
    historyColumn: 'simulacrum_status.id',
    tables: ['simulacrum_status', 'simulacrum_status_catalog'],
  },

  // «Solo abiertos»: records whose current status is one of these are left
  // out. See useCurrentStatus.
  closedStatus: {
    column: 'simulacrum_status_catalog.name',
    values: ['approved', 'canceled'],
  },

  csvConfig: {
    withTables: 'simulacrum_form_answers',
    columns: 'simulacrum_form_answers.uuid,simulacrums.reference_number,simulacrums.evaluation_date,simulacrums.description,simulacrums.created_at,simulacrums.updated_at,simulacrum_template.uuid,simulacrum_template.created_at,simulacrum_template.updated_at,simulacrum_status.created_at,simulacrum_status.updated_at,simulacrum_status_catalog.name,simulacrum_status_catalog.created_at,simulacrum_status_catalog.updated_at,simulacrum_form.uuid,simulacrum_form.name,simulacrum_form.data,simulacrum_form.created_at,simulacrum_form.updated_at,units.description,units.active,centers.name,municipalities.name,sectors.name,regions.name,simulacrum_form_answers.data',
    qualifiedColumns: true,
  },

  viewDefaults: {
    csv: { limit: -1 },
    dataframe: { limit: -1 },
    json: { limit: -1 },
    bar: { stack: 'group' },
  },

  fields: [
    { key: 'simulacrum_form_answers.data', label: 'Formulario - Simulacros', processForm: true },
    { key: 'users.user', label: 'Usuario' },
    { key: 'users.name', label: 'Nombre usuario' },
    { key: 'users.id_profile', label: 'Perfil' },
    { key: 'users.email', label: 'Email usuario' },
    { key: 'units.description', label: 'REMS' },
    { key: 'sectors.name', label: 'Región' },
    { key: 'municipalities.name', label: 'Municipio' },
    { key: 'regions.name', label: 'Estado' },
    { key: 'simulacrums.evaluation_date', label: 'Fecha evaluación', defaultParams: { freq: '1mo' } },
    { key: 'simulacrums.created_at', label: 'Fecha de creación', defaultParams: { freq: '1mo' } },
    { key: 'simulacrums.updated_at', label: 'Fecha de actualización', defaultParams: { freq: '1mo' } },
    { key: 'simulacrum_template.name', label: 'Plantilla' },
    { key: 'simulacrum_form.name', label: 'Formulario' },
    { key: 'simulacrum_status_catalog.name', label: 'Estatus' },
    { key: 'simulacrum_form_answers.answers', label: 'Respuestas' },
    { key: 'simulacrum_template.data', label: 'Datos de plantilla' },
    { key: 'simulacrum_form.data', label: 'Datos de formulario' },
  ],

  filters: [
    ...commonFilters,
    {
      key: 'question',
      label: 'Preguntas del formulario',
      forField: 'Preguntas del formulario',
      filterType: 'process-form',
      optionsConfig: {
        type: 'json-keys',
        dataset: 'simulacrums',
        column: 'simulacrum_form_answers.data',
        limit: -1,
      },
    },
    embedFilter(DATASET_KEY, 'simulacrum_status_catalog.name', 'Estatus', 'status'),
    embedFilter(DATASET_KEY, 'users.user', 'SOEID', 'user_username'),
    embedFilter(DATASET_KEY, 'users.name', 'Nombre usuario', 'user_name'),
    embedFilter(DATASET_KEY, 'users.email', 'Email usuario', 'user_email'),
    {
      key: 'simulacrum_created_at',
      label: 'Fecha de creación',
      filterType: 'where-date',
      whereColumn: 'simulacrums.created_at',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'simulacrum_updated_at',
      label: 'Fecha de actualización',
      filterType: 'where-date',
      whereColumn: 'simulacrums.updated_at',
      optionsConfig: { type: 'date' },
    },
  ],

  dateGrouping: {
    column: 'simulacrum_form_answers.created_at',
    presets: [
      { value: '1d', label: 'Día' },
      { value: '1W', label: 'Semana' },
      { value: '1M', label: 'Mes' },
      { value: '1Y', label: 'Año' },
    ],
  },
}
